module.exports = __webpack_public_path__ + "img/mbanner-image-xs.0425996f.webp";